import React from "react";
import jwtDecode from "jwt-decode";
import { Route, Redirect, withRouter } from "react-router-dom";

export const isAuthorized = (authorizedRoles = []) => {
  const token = localStorage.getItem("accessToken");

  if (token == null) {
    return false;
  }
  // check if token is expired
  const validToken = jwtDecode(token).exp > Math.floor(new Date().getTime() / 1000);
  let rolesGranted = null;

  if (authorizedRoles.length != 0) {
    // GET /users/:id from api instead of localstorage
    const userRole = localStorage.getItem('role');
    // check if user has any of the authorized roles to access this route
    rolesGranted = authorizedRoles.some(r => userRole == r)
  }

  return rolesGranted != null ? Boolean(validToken && rolesGranted) : Boolean(validToken);
};

const PrivateRoute = ({ component: Component, roles, redirectPath = '/login', location: { path }, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthorized(roles, redirectPath) ? (
        <Component {...props} />
      ) : (
          <Redirect
            to={{
              pathname: redirectPath,
              state: {
                from: window.location.pathname,
                redirectReason: roles ? `"${window.location.pathname}" can only be accessed by Users with any of these roles: ${roles.map(r => r)}` : 'Token Expired'
              }
            }}
          />
        )
    }
  />
);

export default withRouter(PrivateRoute);
